<template>
<div>
    <div class="form-group">
        <label class="control-label col-md-2">Condition</label>
        <div class="col-md-10" style="padding-left:20px">
            <div class="row">
                <label class="control-label">Disturbance</label></li>
            </div>
            <div class="row well">
                <div v-for="disturbance in disturbanceSelectedList" class="col-md-3 checkbox checkbox-inline">
                    <input readonly type="checkbox" v-model="disturbance.disturbanceTypeId">
                    <label>{{disturbance.description}}</label>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label>Percent of property badly disturbed</label>
                    <span class="form-control">{{historicalRegisterStatus.disturbancePercent}}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="form-group">
        <label class="col-md-2 control-label">NRHP SIGNIFICANCE</label>
        <div class="col-md-10"  style="padding-left:20px">
            <label>Period(s) of significance</label>
            <div class="row well">
                <div v-for="period in significantPeriodSelectedList" class="col-md-3 checkbox checkbox-inline">
                    <input readonly type="checkbox" v-model="period.significantPeriodId">
                    <label>{{period.description}}</label>
                </div>
            </div>
            <label>Theme(s)</label>
            <div class="row well">
                <div v-for="theme in themeSelectedList" class="col-md-3 checkbox checkbox-inline">
                    <input readonly type="checkbox" v-model="theme.themeId">
                    <label>{{theme.description}}</label>
                </div>
            </div>
        </div>
    </div>
    <div class="form-group">
        <label class="col-md-4 col-md-offset-2 text-label">Discuss period of significance</label>
    </div>
    <div class="form-group">
        <div class="col-md-10 col-md-offset-2 text-label">
            {{historicalRegisterStatus.periodDescription}}
        </div>
    </div>
</div>
</template>

<script>

import loggingService from '../../services/util/loggingService'
import disturbanceService from '../../services/siteForm/disturbanceService'
import significantPeriodService from '../../services/siteForm/significantPeriodService'
import themeService from '../../services/siteForm/ThemeService'
import historicalRegisterStatusService from '../../services/siteForm/HistoricalRegisterStatusService'

export default {
    name: 'NationalRegisterStatusForm',
    components: {
    },
    props: ['historicalRegisterStatusInstance', 'crrId'],
    data: function () {
        return {
            isDebug: false,
            disturbanceSelectedList: [],
            significantPeriodSelectedList: [],
            themeSelectedList: [],
            eligibilityCriteriaList: [],
            historicalRegisterStatus: {}
        }
    },
    mounted () {
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'NationalRegisterStatusForm', message)
        },
        loadDisturbances () {
            this.log('load disturbance')
            var searchDto = {historicalRegisterStatusInstanceId: this.historicalRegisterStatus.historicalRegisterStatusInstanceId}
            return disturbanceService.search(this.$http, searchDto).then(result => {
                this.log('disturbance[0]:' + result.data[0])
                this.disturbanceSelectedList = disturbanceService.getDisturbanceList().filter(disburbance => {
                    return result.data.some(x => x.disturbanceTypeId === disburbance.disturbanceTypeId)
                })
            })
        },
        loadSignificantPeriods () {
            this.log('load Sig period')
            var searchDto = {historicalRegisterStatusInstanceId: this.historicalRegisterStatus.historicalRegisterStatusInstanceId}
            return significantPeriodService.search(this.$http, searchDto).then(result => {
                this.significantPeriodSelectedList = significantPeriodService.getSignificantPeriodList().filter(period => {
                    return result.data.some(x => x.significantPeriodId === period.significantPeriodId)
                })
            })
        },
        loadThemes () {
            this.log('load theme')
            var searchDto = {historicalRegisterStatusInstanceId: this.historicalRegisterStatus.historicalRegisterStatusInstanceId}
            return themeService.search(this.$http, searchDto).then(result => {
                this.themeSelectedList = themeService.getThemeList().filter(theme => {
                    return result.data.some(x => x.themeId === theme.themeId)
                })
            })
        },
        loadData () {
            this.log('Loading Data for crrId: ' + this.crrId)
            return historicalRegisterStatusService.search(this.$http, {culturalResourceRecordingId: this.crrId}).then(response => {
                if (response.data.length > 0) {
                    this.log('found one response')
                    this.historicalRegisterStatus = response.data[0]
                    this.log('enrolled:' + this.historicalRegisterStatus.isEnrolledOnNrhp)
                    Promise.all([
                        this.loadDisturbances(),
                        this.loadSignificantPeriods(),
                        this.loadThemes()
                    ]).then(response2 => {
                        this.log('done loading others')
                        return response2
                    })
                } else {
                    this.log('no data found')
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// NationalRegisterStatus.vue?86629374